<template>
	<div id="app" v-touch:tap='onClick' class="w-full h-full">
		<div class="app-content w-full h-full flex flex-col">
			<div class="top-content flex flex-col">
				<Header/>
			</div>
			<div class="content">
				<div id="map-area-container" class="map-area-container" :class="{'map-search-visible': searchVisible}">
					<WFMap :class="{'map-popup-open': isPOIPopupVisible()}" @poiClicked="onMapPOIClick" @onTouch="onClick" @loaded="mapLoaded" ref="map" :project="project" :api="apiHost" :assets="assetHost"/>
					<div class="map-overlay absolute">
						<div class="map-overlay-left">
							<WFLanguagesMenu class="map-menu" :showFlag="false" labelType="code"/>
						</div>
						<div class="map-overlay-center">
							<WFShortcutsMenu class="map-menu" :showLabel="false" @clicked="showShortcut"></WFShortcutsMenu>
							<div class="map-menu">
								<div class="wf-list-item" @click="showYAH">
									<WFIcon name="yah"></WFIcon>
								</div>
							</div>
						</div>
						<div class="map-overlay-right">
							<WFFloorsMenu class="map-menu" :currentFloor="currentFloor" :hideWhenSingleFloor="true"/>
							<WFZoomMenu></WFZoomMenu>
						</div>
					</div>
					<DirectionsPanel ref="directionsPanel" @routeShown="onDirectionsRouteShown" @routeCleared="onDirectionsRouteCleared" />
					<div class="menu-curve"></div>
					<div class="map-shadow" :class="{'active': mapShadow}" @click="closeShadow">
						<div v-show="showFloorText">
							<label class="shadowText">{{mapFloorText}}</label>
							<WFTranslate k="just-floor">korrus</WFTranslate>
						</div>
					</div>
					<div id="poi-popup" ref="poiPopup" v-show="isPOIPopupVisible()">
						<div class="poi-popup-content" v-if="popupPOI">
							<label class="title" target="_new">{{popupPOI.getName(language)}}</label>
							<button class="btn btn-border btn-center" @click="showPath(popupPOI)"><WFIcon name="path"></WFIcon><WFTranslate k="show_path">Näita teekonda</WFTranslate></button>
							<button class="btn btn-border btn-active btn-center" @click="onPopupPOIClick(popupPOI)"><WFIcon name="info"></WFIcon><WFTranslate k="info">Info</WFTranslate></button>
						</div>
						<div class="pin-down"></div>
					</div>
					<div class="menu-shadow"></div>
				</div>
				<div class="menus bg-white" :class="{'menu-active': menuActive}" >
					<div class="menus-container flex flex-col">
						<TopBar :class="{'search-visible': !topBarSearch}" @clicked="onGroupMenuClick" @search="showSearch" @closeSearch="onSearchClose" @showMenu="showMenu" :currentGroup="currentGroup" :active="activeTab" :searchVisible="searchVisible"></TopBar>
						<WFTabs ref="tabs" :activeTab="currentTab">
							<WFTab name="pois">
								<POIs :currentGroup="currentGroup" :currentPOI="currentPOI" @showPath="showPath" @showOnMap="showOnMap" @onPOIClick="onPOIClick"></POIs>
							</WFTab>
							<WFTab name="search">
								<Search @showPath="showPath" @onPOIClick="onPOIClick" @close="onSearchClose" :currentPOI="currentPOI" ref="search"/>
							</WFTab>
							<WFTab name="pages">
								<Pages ref="pages" @showRoute="showPagePath" @viewOnMap="viewPageOnMap" :container="pageContainer" :pageSlug="pageSlug"/>
							</WFTab>
						</WFTabs>
					</div>
				</div>
			</div>
			<Footer />
		</div>
		<div id="screensaver" class="banners-screensaver hide-mobile" v-show="screensaver" @click="hideBanner()">
			<WFBanner template="default" container="screensaver" class="hide-portrait" @clicked="onBannerClick" @hasbanners="hasBanners" :qrURL="qrURL"></WFBanner>
			<WFBanner template="default" container="screensaver-portrait" class="hide-landscape" @clicked="onBannerClick" @hasbanners="hasBanners" :qrURL="qrURL"></WFBanner>
		</div>
	</div>
</template>

<script>
import { WFMap, WFFloorsMenu, WFBanner, WFShortcutsMenu, WFLanguagesMenu, WFTranslate } from '@3dwayfinder/wayfinder-vue-components'
import TopBar from './components/TopBar';
import Search from './components/Search';
import POIs from './components/POIs';
import Pages from './components/Pages';
import Footer from './components/Footer';
import Header from './components/Header';
import DirectionsPanel from './components/DirectionsPanel';
import { mapState } from 'vuex';

export default {
	name: 'app',
	components: {
		WFMap,
		WFFloorsMenu,
		WFBanner,
		WFShortcutsMenu,
		WFLanguagesMenu,
		TopBar,
		Search,
		Footer,
		Header,
		WFTranslate,
		POIs,
		Pages,
		DirectionsPanel
	},
	data () {
		return {
			lastClick: false,
			screensaver: false,
			hasScreensaver: false,
			menuActive: false,
			azActive: true,
			overlayImage: -1,
			poiOpen: false,
			overlayOpen: false,
			tingmargidOpen: false,
			currentGroup: null,
			searchVisible: false,
			qrURL: "https://clients.3dwayfinder.com/Rautatieasema/?kiosk={kiosk}&map2DRotation={rot}",			
			openingHours: "",
			activeTab: "",
			mapShadow: false,
			popupPOI: null,
			poiPopupVisible: false,
			currentVisible: false,
			mapFloorText: "",
			showFloorText: false,
			overrideChar: "",
			currentTab: "pois",
			pageContainer: "default",
			zoomPOIs: null,
			pageSlug: null,
			idleTimer: null,
			idleTimeout: 60000,
			
			// DYNAMIC COLOR SETTINGS
			settingsData: {
				colors: {
					'primary': '#B58BF9',           
					'primary-content': '#FFFFFF',   // White text on primary
					'secondary': '#333333',
					'secondary-content': '#FFFFFF',
					'accent': '#f5f5f5',
					'accent-content': '#333333',
					'active': '#C19EFA',            // Same as primary for active states
					'base': '#FFFFFF',
					'base-content': '#333333',
					'border': '#E0E0E0',
				}
			}
		}
	},
	computed: {
		...mapState('wf', ['maxInActivity', 'currentFloor', 'mobile', 'pois', 'language', 'landscape', 'portrait', 'poiGroups']),
		...mapState(['currentPOI']),
		apiHost () {
			return this.$WF_API_HOST;
		},
		assetHost () {
			return this.$WF_ASSET_HOST;
		},
		project () {
			return this.$WF_PROJECT;
		},
		topBarSearch () {
			return !this.landscape || (this.landscape && !this.searchVisible && this.activeTab == "");
		},
		isLocalhost() {
			return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192.168');
		}
	},
	mounted () {
		this.resize();

		window.onresize = () => {
			this.resize();
		}
		
		
		if (this.isLocalhost) {
			this.applyColorSettings();
		}
		this.startIdleTimer();
		const resetIdleTimer = () => {
			this.resetIdleTimer();
		};
		document.addEventListener('click', resetIdleTimer);
		document.addEventListener('touchstart', resetIdleTimer);
		document.addEventListener('mousemove', resetIdleTimer);
		document.addEventListener('keypress', resetIdleTimer);
		document.addEventListener('scroll', resetIdleTimer);
	},
	methods: {
		
		loadSettings() {
			try {
				const wf = this.$wayfinder || window.wayfinder;
				
				if (this.isLocalhost) {
					this.applyColorSettings();
					return;
				}
				
				if (wf && wf.settings) {
					const primaryColor = wf.settings['template.color.primary'] || '#B58BF9';
					const primaryContent = wf.settings['template.color.primary-content'] || '#FFFFFF';
					
					this.settingsData.colors = {
						'primary': primaryColor,
						'primary-content': primaryContent,
						'secondary': wf.settings['template.color.secondary'] || '#333333',
						'secondary-content': wf.settings['template.color.secondary-content'] || '#FFFFFF',
						'accent': wf.settings['template.color.accent'] || '#f5f5f5',
						'accent-content': wf.settings['template.color.accent-content'] || '#333333',
						'active': primaryColor,
						'active-content': primaryContent,
						'base': wf.settings['template.color.base-100'] || '#FFFFFF',
						'base-content': wf.settings['template.color.base-content'] || '#333333',
						'border': wf.settings['template.color.border'] || '#E0E0E0',
					};
					
					console.log('Colors loaded from CMS:', this.settingsData.colors);
				}
				
				this.applyColorSettings();
			} catch (error) {
				console.error('Error loading settings:', error);
				this.applyColorSettings();
			}
		},
		
		applyColorSettings() {
			const colors = this.settingsData.colors;
			const root = document.documentElement;
			
			
			root.style.setProperty('--th-primary', colors['primary']);
			root.style.setProperty('--th-primary-content', colors['primary-content']);
			root.style.setProperty('--th-secondary', colors['secondary']);
			root.style.setProperty('--th-secondary-content', colors['secondary-content']);
			root.style.setProperty('--th-accent', colors['accent']);
			root.style.setProperty('--th-accent-content', colors['accent-content']);
			root.style.setProperty('--th-active', colors['active']);
			root.style.setProperty('--th-active-content', colors['active-content']);
			root.style.setProperty('--th-base', colors['base']);
			root.style.setProperty('--th-base-content', colors['base-content']);
			root.style.setProperty('--th-border', colors['border']);
			
			console.log('Colors applied - Primary:', colors['primary']);
		},
		
		
		setSearchInput (input) {
			if (this.$refs.search && input) {
				this.$refs.search.setOutput(input);
			}
		},
		filterPOIs (pois) {
			pois = pois.filter(p => {
				return p && p.getShowInMenu() && p.getName(this.language) !== ""
			});
			this.filteredPOIs = [];
			this.filteredPOIs = pois.map(p => {
				return Object.freeze(p);
			});
			this.$store.dispatch('wf/SET_FILTERED_POIS', this.filteredPOIs);
		},
		onClick () {
			clearTimeout(this.lastClick);
			this.$refs['map'].run();
			
			this.lastClick = setTimeout(() => {
				this.reset();
				this.$refs.map.reset();
			}, this.maxInActivity * 1000);
			return false;
		},
		filterAZ () {
			this.filterPOIs(this.pois);
			this.azActive = true;
			this.mapShadow = false;
			this.$store.dispatch('wf/SET_CURRENT_GROUP', {id: -1});
			this.currentGroup = null;
			this.overrideChar = "nochar";
			if (this.$refs.filterscroll)
				this.$refs.filterscroll.reset();
		},
		changeTab (tab) {
			this.currentTab = tab;			
		},
		onGroupMenuClick (group, keepopen) {
			this.azActive = false;
			this.mapShadow = false;
			console.log('onGroupMenuClick', group, this.currentGroup)
			if (group && this.currentGroup && this.currentGroup.id == group.id && !keepopen) {
				this.menuActive = false;
				this.currentGroup = null;
				if(this.$wayfinder)
					this.$wayfinder.clearHighlights();
			}
			else {
				this.currentGroup = Object.freeze(Object.assign({}, group));
				this.menuActive = true;
				
				if(this.$wayfinder) {
					this.$wayfinder.clearHighlights();
					this.$wayfinder.setHighlights(this.currentGroup.pois);
				}
					
			}
			
			if(this.currentGroup && this.currentGroup.slug && this.currentGroup.slug.indexOf("page-") == 0) {
				console.log('slug', this.currentGroup.slug, this.currentGroup.slug.indexOf("page-"))
				this.currentTab = "pages";
				console.log('group-menu', this.currentGroup.slug, this.currentGroup.slug.substring(5))
				this.showPage(this.currentGroup.slug.substring(5))
			}
			else {
				this.currentTab = "pois";
				this.pageContainer = "default";
			}

			this.mapShadow = false;
			this.searchVisible = false;
			
			this.$store.dispatch('setPOI', null);
		},
		filterChar (char, pois) {
			this.overrideChar = char;
			this.filterPOIs(pois);
			this.$nextTick(() => {
				this.$nextTick(() => {
					if (this.$refs.filterscroll)
						this.$refs.filterscroll.reset();
				});
			});
		},
		onMapPOIClick (poi) {
			this.$wayfinder.clearHighlights();

			if (poi && poi.getShowInMenu()) {
				this.$store.dispatch('setPOI', Object.freeze(poi));

				this.$wayfinder.setHighlights([poi]);
				if(poi.getNode()) {
					this.$wayfinder.showFloor(poi.getFloor())
					this.popupPOI = Object.freeze(poi);
					this.showPOIPopup(poi);
					this.currentVisible = true;
				}
			}
		},
		onPopupPOIClick (poi) {
			this.poiPopupVisible = false;
			if (poi && poi.getShowInMenu()) {
				let groups = poi.getGroups().filter(g => g.parent == null);

				if (groups && groups.length > 0) {
					let parent = this.poiGroups.find((p)=> {
						return p.id == groups[0].parent_id;
					})
					this.onGroupMenuClick(parent, true);
					this.pageSlug = groups[0].slug;
					this.$store.dispatch('setPOI', Object.freeze(poi));
				}
			}
		},
		clearShortcut() {
			this.poiPopupVisible = false;
			this.$wayfinder.clearPath();
			this.$wayfinder.clearHighlights();
			this.$wayfinder.clearDisplaying();
			this.$wayfinder.setDehighlightOverlay(false);
		},
		showShortcut (nearest, group) {
			this.clearShortcut();
			let overlay = "";
			
			switch(group.id) {
				default:
					if (nearest) {
						this.$wayfinder.showPath(nearest.node, nearest);
					}
				break;
			}

			if(overlay != "") {
				this.$nextTick(()=> {
					this.openOverlay(overlay, true);
					this.$wayfinder.setDehighlightOverlay(true);
					this.$wayfinder.setDisplaying(group.pois);
					this.$wayfinder.setHighlights(group.pois);
				})
			}
		},
		showSearch () {
			this.searchVisible = true;
			this.currentGroup = null;
			this.menuActive = true;
			this.currentTab = "search";
		},
		showPage (container) {
			this.pageContainer = container;
			this.changeTab("pages");
		},
		getPOIbyType (type, slug) {
			let poi = null;
			let group, room;
			switch(type) {
				case "group":
					group = this.$wayfinder.getGroupWithSlug(slug);
					if(group && group.getPOIs().length > 0) {
						poi = this.$wayfinder.getNearestPOI(this.$wayfinder.getKiosk(), group.getPOIs());
					}
					break;
				case "poi":
					room = this.$wayfinder.getRoom(slug);
					if (room && room.pois.length > 0) {
						poi = room.getPOIs()[0]
					}
					break;
				default:
					poi = null;
			}

			return poi;
		},
		showPagePath (type, slug) {
			let poi = this.getPOIbyType(type, slug);
			console.log('showPagePath', type, slug, poi);
			if (poi) {
				this.$wayfinder.showPath(poi.node, poi);
			}
			
		},
		viewPageOnMap (type, slug) {
			let poi = this.getPOIbyType(type, slug);

			if(poi) {
				this.$wayfinder.showFloor(poi.getFloor())
				this.$wayfinder.setHighlights([poi]);
			}
		},
		onPOIClick (poi) {
			this.searchVisible = false;			
			this.$store.dispatch('setPOI', Object.freeze(poi));
			
			this.activeTab = "";
			this.mapShadow = false;
			this.$wayfinder.clearHighlights();
			this.$wayfinder.setHighlights([poi]);

			this.currentTab = "pois";
			let groups = poi.getGroups();
			for(let g in groups) {
				if(groups[g].getShowInMenu()) {
					this.currentGroup = Object.freeze(Object.assign({}, groups[g]));
					break;
				}
			}
			
			if (this.$refs.filterscroll) {
				console.log('scroll.reset')
				this.$refs.filterscroll.reset();
			}
		},
		openTopics () {
			this.searchVisible = false;
			this.overlayOpen = false;
			this.poiOpen = false;
			this.mapShadow = false;
			this.activeTab = this.activeTab == "topics" ? "" : "topics";
		},
		closePOI () {
			this.poiOpen = false;
			this.mapShadow = false;
		},
		closeShadow () {
			this.poiOpen = false;
			this.mapShadow = false;
			this.overlayOpen = false;
		},
		onSearchPOIClick (poi) {
			if (poi) {
				this.onPOIClick(poi);
				
			}
		},
		showPath (poi) {
			this.poiPopupVisible = false;
			this.$wayfinder.showPath(poi.getNode(), poi)
			this.$wayfinder.clearHighlights();
			this.$wayfinder.setHighlights([poi]);
		},
		showMenu () {
			this.menuActive = !this.menuActive;

			if (!this.menuActive) {
				this.searchVisible = false;
				this.currentGroup = null;
				this.$store.dispatch('setPOI', null);
			}
			else {
				this.onGroupMenuClick(Object.freeze(Object.assign({}, this.$wayfinder.mainGroups[0])));
			}
		},
		showOnMap (poi) {
			this.$wayfinder.clearDisplaying();
			this.$wayfinder.clearHighlights();
			if (poi) {
				this.$wayfinder.showFloor(poi.getFloor());
				this.$wayfinder.clearPath()
				this.$wayfinder.setHighlights([poi]);
				this.$wayfinder.setDisplaying([poi]);
				this.showPOIPopup(poi);
			}
		},
		onSearchClose () {
			if (this.$refs.search)
				this.$refs.search.resetValues();
			this.searchVisible = false;
			this.menuActive = false;
		},
		reset () {
			let preset = this.$options.data();
			delete preset["openingHours"];
			delete preset["settingsData"]; // Don't reset color settings
			delete this.$data;
			
			Object.assign(this.$data, { ...preset });
			this.$store.dispatch('wf/SET_RESET');
			this.clearShortcut();
			let g = this.$wayfinder.getGroupWithSlug("zoom");
			this.zoomPOIs = g ? g.getPOIs().map(p => {
				return Object.freeze(p);
			}) : null;

			if (this.zoomPOIs) {
				this.$wayfinder.fitMultiplePOIsInView(this.zoomPOIs);
			}
		},
		resize () {
			let _l = window.matchMedia("(orientation: landscape)");
			let _pm = window.matchMedia("(max-height: 1024px) and (orientation: portrait)");
			let _lm = window.matchMedia("(max-width: 1024px) and (orientation: landscape)");
			let landscape = _l ? _l.matches : false;
			let mobile = (_pm ? _pm.matches : false) || (_lm ? _lm.matches : false);
			this.$store.dispatch('wf/SET_LANDSCAPE', landscape);
			this.$store.dispatch('wf/SET_MOBILE', mobile);
		},
		doSomething () {},
		onBannerClick (/*frame, container*/) {
			this.screensaver = false;
			this.$refs['map'].run();
		},
		toGroups () {
			this.changeTab('groups');
		},
		hideBanner () {
			this.screensaver = false;
		},
		showPOIPopup (poi) {
			this.popupPOI = Object.freeze(poi);
			let width = 155;
			let position = this.$wayfinder.getScreenPosition(poi);	
			let offset =  (this.$wayfinder.settings.getFloat("poi.2d.icon-size", 24, poi) - 24) / 2;
			this.$refs.poiPopup.style.left = position[0] + "px";

			this.$nextTick(() => {			
				this.$refs.poiPopup.style.top = position[1] - offset + "px";
				this.$refs.poiPopup.style.marginTop = "revert-layer";
				this.$refs.poiPopup.style.marginLeft = "revert-layer";
				this.$refs.poiPopup.classList.remove("pin-up");
				this.$refs.poiPopup.classList.remove("pin-left");
				this.$refs.poiPopup.classList.remove("pin-right");


				if(position[1] < 100) {
					this.$refs.poiPopup.style.marginTop = (- offset * 2) + "px";
					this.$refs.poiPopup.classList.add("pin-up");
				}

				if(position[0] < width / 2) {
					this.$refs.poiPopup.style.marginLeft = -position[0] + "px";
					this.$refs.poiPopup.classList.add("pin-left");
				}
			});
			
			this.poiPopupVisible = true;
		},
		hidePOIPopup () {
			this.poiPopupVisible = false;
		},
		isPOIPopupVisible () {
			return (this.$wayfinder && this.popupPOI && this.poiPopupVisible && this.popupPOI.getNode().floor == this.$wayfinder.getCurrentFloor())
		},
		mapLoaded () {
			this.$refs['map'].run();
			
			if(this.$wayfinder) {
				this.$wayfinder.options.pathDisplayInstructions = false;
			}

			
			this.loadSettings();

			this.qrURL = this.qrURL.replace("{kiosk}", this.$wayfinder.getKiosk());
			this.qrURL = this.qrURL.replace("{rot}", 0);

			this.$wayfinderApp.loadPages();
			let resizeObserver;
			let _canvas = document.getElementById("map-area-container");
			
			if (typeof ResizeObserver != "undefined" && _canvas) {
				let obtimer;
				let g = this.$wayfinder.getGroupWithSlug("zoom");
				this.zoomPOIs = g ? g.getPOIs().map(p => {
					return Object.freeze(p);
				}) : null;

				resizeObserver = new ResizeObserver(() => {
					clearTimeout(obtimer);
					obtimer = setTimeout(() => {
						this.$wayfinder.resize();
						this.$wayfinder.showKiosk();
						console.log('fit', this.zoomPOIs);
						if(this.zoomPOIs) {
							
							this.$wayfinder.fitMultiplePOIsInView(this.zoomPOIs);
						}
						console.log('Size changed2');
					}, 25)
				});
					
				resizeObserver.observe(_canvas);
			}

			this.$wayfinder.events.on("map-update", () => {
				if (this.poiPopupVisible && this.popupPOI) {
					this.showPOIPopup(this.popupPOI);
				}	
			});

			this.$wayfinder.events.on("floor-change", (floor) => {
				if (this.poiPopupVisible && this.popupPOI && this.popupPOI.floor == floor) {
					this.showPOIPopup(this.popupPOI);
				}
				else {
					this.poiPopupVisible = false;
				}
			});

			this.$wayfinder.events.on("floor-change-before", (floor) => {
				console.log('before-floor-change')
				if(this.pathAnimation) {
					this.mapShadow = true;
					this.mapFloorText = floor.getName(this.language);
					setTimeout(() => {
						console.log('before-floor-change-end')
						this.mapShadow = false;
						this.mapFloorText = "";
						this.showFloorText = false;
					}, 3000);
				}
			});

			this.$wayfinder.events.on("path-start", () => {
				console.log('path-start');
				this.pathAnimation = true;
				this.showFloorText = true;
			});

			this.$wayfinder.events.on("path-finished", () => {
				console.log('path-end');
				this.pathAnimation = false;
				this.showFloorText = false;
			});

			this.$wayfinder.events.on("map-touch", () => {
				this.poiPopupVisible = false;
				this.tingmargidOpen = false;
				this.mapShadow = false;
				this.clearShortcut();
				this.overlayOpen = false;
			});			
		},
		hasBanners (has) {
			this.hasScreensaver = has;
		},
		openOverlay (name, mapShadow) {
			this.clearShortcut();
			if (this.activeTab != name) {
				this.overlayOpen = true;
				this.searchVisible = false;
				this.activeTab = name;
				this.mapShadow = !mapShadow;
			}
			else {
				this.closeOverlay();
			}
		},
		closeOverlay () {
			this.overlayOpen = false;
			this.mapShadow = false;
			this.activeTab = "";
		},
		openBrowser () {
			this.browserOpen = true;
		},
		closeBrowser () {
			this.browserOpen = false;
		},
		toggleTingmargid () {
			this.tingmargidOpen = !this.tingmargidOpen;
		},
		translate (key, params) {
			return this.$wayfinder.translator.get(key, params)
		},
		getBanner (tab) {
			let url = "";
			switch (tab) {
				case "uldinfo":
					url = "./banners/uldinfo.jpg"
				break;
				case "kinkekaart":
					url = "./banners/kinkekaart.jpg"
				break;
				case "kinkekaart2":
					if (this.landscape)
						url = "./banners/kinkekaart.jpg"
				break;
			}

			return url;
		},
		getOverlayTitle (tab) {
			if(this.$wayfinder) {
				return this.$wayfinder.translator.get('sisu-pealkiri-'+tab);
			}
			else {
				return "";
			}
		},
		showYAH () {
			this.$wayfinder.showKiosk();
			if(this.zoomPOIs)
				this.$wayfinder.fitMultiplePOIsInView(this.zoomPOIs);
		},
		onDirectionsRouteShown (data) {
			console.log('Route shown from', data.start, 'to', data.end);
			
			this.menuActive = false;
			this.searchVisible = false;
		},
		onDirectionsRouteCleared () {
			console.log('Route cleared');
		},
		startIdleTimer() {

    if (this.idleTimer) {
        clearTimeout(this.idleTimer);
    }
    this.idleTimer = setTimeout(() => {
        
        if (this.hasScreensaver) {
            this.screensaver = true;
        } else {
            window.location.reload();
        }
    }, this.idleTimeout);
},
		resetIdleTimer() {
			
			this.startIdleTimer();
		}
	}
};
</script>

<style lang="less">
	@import 'css/styles';
	@import 'css/responsive';
</style>